import React, { useState } from 'react';
import styles from "./styles.module.css";
import Header from './components/header';
import AdSense from 'react-adsense';
import Footer from './components/footer'

function MainPage() {

    const [selectedImg, setSelectedImg] = useState('');
    const [abreModal, setAbreModal] = useState(false);

    function handleClickImage(src) {
        setSelectedImg(src);
        setAbreModal(true);
    }

    function renderModal() {
        if (abreModal)
            return (
                <div className={styles.modal}>
                    <input type="button" value="X" className={styles.closebytton} onClick={() => setAbreModal(false)} />
                    <img className={styles.imggalery} src={selectedImg} alt={selectedImg}></img>
                </div>
            )
    }
    return (
        <>
            <Header />
            <h1>BEM VINDOS AO NANDA CONFEITOS</h1>
            <h2>CONFIRAM NOSSAS GULOSEIMAS</h2>
            <h3>Nanda confeitos, guloseimas feitas com carinho para satisfazer seus doces desejos.</h3>
            <div className={styles.container}>
                <div className={styles.row}>
                    <div className={styles.col}>
                        <div className={styles.brackground}><img className={styles.stretch} src="/images/img1.webp" alt="NANDA CONFEITOS IMG1" onClick={() => handleClickImage('/images/img1.webp')}></img></div>
                    </div>
                    <div className={styles.col}>
                        <div className={styles.brackground}><img className={styles.stretch} src="/images/img2.webp" alt="NANDA CONFEITOS IMG2" onClick={() => handleClickImage('/images/img2.webp')}></img></div>
                    </div>

                    <div className={styles.col}>
                        <div className={styles.brackground}><img className={styles.stretch} src="/images/img3.webp" alt="NANDA CONFEITOS IMG3" onClick={() => handleClickImage('/images/img3.webp')}></img></div>
                    </div>
                    <div className={styles.col}>
                        <div className={styles.brackground}><img className={styles.stretch} src="/images/img4.webp" alt="NANDA CONFEITOS IMG4" onClick={() => handleClickImage('/images/img4.webp')}></img></div>
                    </div>
                </div>
            </div>
            {renderModal()}
            <AdSense.Google
                client='ca-pub-9626376842149316'
                slot='7948839524'
                style={{ display: 'block' }}
                layout="in-article"
                format="fluid"
            />
            <Footer/>
        </>
    )
}

export default MainPage;